import React, { useState } from 'react';
import { 
  FaEnvelope, 
  FaPhone, 
  FaMapMarkerAlt, 
  FaClock,
  FaLinkedin, 
  FaGithub, 
  FaInstagram, 
  FaWhatsapp,
  FaGlobe // يمكنك تغييره إلى FaBriefcase أو FaUserTie إذا أحببت
} from 'react-icons/fa';


const Contact = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    subject: '',
    message: ''
  });
  
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState({
    success: null,
    message: ''
  });

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [id]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus({ success: null, message: '' });

    try {
      const response = await fetch('https://my-portfoli-backed.onrender.com/api/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (response.ok) {
        setSubmitStatus({
          success: true,
          message: 'تم إرسال رسالتك بنجاح! سنتواصل معك قريباً.'
        });
        // Reset form after successful submission
        setFormData({
          fullName: '',
          email: '',
          subject: '',
          message: ''
        });
      } else {
        setSubmitStatus({
          success: false,
          message: data.message || 'حدث خطأ أثناء إرسال الرسالة. يرجى المحاولة مرة أخرى.'
        });
      }
    } catch (error) {
      setSubmitStatus({
        success: false,
        message: 'حدث خطأ في الاتصال بالخادم. يرجى التحقق من اتصالك بالإنترنت والمحاولة مرة أخرى.'
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const styles = {
      container: {
      backgroundColor: '#ffffff',
      color: '#333333',
      minHeight: '100vh',
      padding: '2rem 1rem',
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      lineHeight: '1.6'
    },
    content: {
      maxWidth: '900px',
      margin: '0 auto',
      display: 'grid',
      gridTemplateColumns: '1fr',
      gap: '2rem',
      '@media (min-width: 768px)': {
        gridTemplateColumns: '1fr 1fr',
        padding: '2rem'
      }
    },
    header: {
      textAlign: 'center',
      marginBottom: '2rem',
      borderBottom: '2px solid #000000',
      paddingBottom: '1rem',
      gridColumn: '1 / -1'
    },
    title: {
      fontSize: '2rem',
      fontWeight: '700',
      color: '#000000',
      marginBottom: '0.5rem',
      '@media (min-width: 768px)': {
        fontSize: '2.5rem'
      }
    },
    subtitle: {
      fontSize: '1rem',
      color: '#555555',
      fontWeight: '300',
      '@media (min-width: 768px)': {
        fontSize: '1.2rem'
      }
    },
    contactInfo: {
      padding: '1rem',
      '@media (min-width: 768px)': {
        padding: '1.5rem'
      }
    },
    infoTitle: {
      fontSize: '1.5rem',
      fontWeight: '600',
      marginBottom: '1rem',
      color: '#000000',
      '@media (min-width: 768px)': {
        fontSize: '1.8rem',
        marginBottom: '1.5rem'
      }
    },
    infoItem: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '1rem',
      flexDirection: 'row-reverse', // For RTL layout
      '@media (min-width: 768px)': {
        marginBottom: '1.5rem'
      }
    },
    icon: {
      width: '40px',
      height: '40px',
      backgroundColor: '#f5f5f5',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginLeft: '1rem',
      fontSize: '1rem',
      color: '#000000',
      '@media (min-width: 768px)': {
        width: '50px',
        height: '50px',
        fontSize: '1.2rem'
      }
    },
    infoContent: {
      flex: 1,
      textAlign: 'right' // For RTL layout
    },
    infoLabel: {
      fontSize: '0.8rem',
      color: '#777777',
      marginBottom: '0.3rem',
      '@media (min-width: 768px)': {
        fontSize: '0.9rem'
      }
    },
    infoText: {
      fontSize: '1rem',
      fontWeight: '500',
      '@media (min-width: 768px)': {
        fontSize: '1.1rem'
      }
    },
    infoLink: {
      color: '#000000',
      textDecoration: 'none',
      transition: 'color 0.3s ease',
      ':hover': {
        color: '#555555'
      }
    },
    contactForm: {
      padding: '1rem',
      border: '1px solid #eeeeee',
      borderRadius: '8px',
      '@media (min-width: 768px)': {
        padding: '1.5rem'
      }
    },
    formTitle: {
      fontSize: '1.5rem',
      fontWeight: '600',
      marginBottom: '1rem',
      color: '#000000',
      '@media (min-width: 768px)': {
        fontSize: '1.8rem',
        marginBottom: '1.5rem'
      }
    },
    formGroup: {
      marginBottom: '1rem',
      '@media (min-width: 768px)': {
        marginBottom: '1.5rem'
      }
    },
    formLabel: {
      display: 'block',
      marginBottom: '0.5rem',
      fontWeight: '500',
      textAlign: 'right' // For RTL layout
    },
    formInput: {
      width: '100%',
      padding: '0.7rem',
      border: '1px solid #dddddd',
      borderRadius: '4px',
      fontSize: '0.9rem',
      transition: 'border-color 0.3s ease',
      textAlign: 'right', // For RTL layout
      ':focus': {
        outline: 'none',
        borderColor: '#000000'
      },
      '@media (min-width: 768px)': {
        padding: '0.8rem',
        fontSize: '1rem'
      }
    },
    textArea: {
      minHeight: '120px',
      resize: 'vertical',
      '@media (min-width: 768px)': {
        minHeight: '150px'
      }
    },
    submitButton: {
      backgroundColor: '#000000',
      color: '#ffffff',
      border: 'none',
      padding: '0.7rem 1.2rem',
      borderRadius: '4px',
      fontSize: '0.9rem',
      fontWeight: '500',
      cursor: 'pointer',
      transition: 'background-color 0.3s ease',
      width: '100%',
      ':hover': {
        backgroundColor: '#333333'
      },
      '@media (min-width: 768px)': {
        padding: '0.8rem 1.5rem',
        fontSize: '1rem',
        width: 'auto'
      }
    },
    socialSection: {
      marginTop: '1.5rem',
      paddingTop: '1.5rem',
      borderTop: '1px solid #eeeeee',
      '@media (min-width: 768px)': {
        marginTop: '2rem',
        paddingTop: '2rem'
      }
    },
    socialTitle: {
      fontSize: '1.1rem',
      fontWeight: '600',
      marginBottom: '0.8rem',
      color: '#000000',
      textAlign: 'right', // For RTL layout
      '@media (min-width: 768px)': {
        fontSize: '1.2rem',
        marginBottom: '1rem'
      }
    },
    socialLinks: {
      display: 'grid',
      gridTemplateColumns: 'repeat(2, 1fr)',
      gap: '0.8rem',
      '@media (min-width: 480px)': {
        gridTemplateColumns: 'repeat(3, 1fr)'
      },
      '@media (min-width: 768px)': {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '1rem'
      }
    },
    socialLink: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '0.6rem 0.8rem',
      backgroundColor: '#f5f5f5',
      borderRadius: '4px',
      textDecoration: 'none',
      color: '#333333',
      transition: 'all 0.3s ease',
      fontSize: '0.8rem',
      ':hover': {
        backgroundColor: '#000000',
        color: '#ffffff'
      },
      '@media (min-width: 768px)': {
        padding: '0.8rem 1.2rem',
        fontSize: '0.9rem'
      }
    },
    socialIcon: {
      marginLeft: '0.5rem',
      fontSize: '0.9rem',
      '@media (min-width: 768px)': {
        fontSize: '1rem'
      }
    },
    socialName: {
      fontSize: '0.8rem',
      fontWeight: '500',
      '@media (min-width: 768px)': {
        fontSize: '0.9rem'
      }
    },
    statusMessage: {
      marginTop: '1rem',
      padding: '0.8rem',
      borderRadius: '4px',
      textAlign: 'center',
      fontWeight: '500'
    },
    success: {
      backgroundColor: '#e6ffed',
      color: '#2d8a4a'
    },
    error: {
      backgroundColor: '#fff5f5',
      color: '#dc3545'
    }
  };

  const socialMedia = [
{ name: 'LinkedIn', icon: <FaLinkedin />, url: 'https://www.linkedin.com/in/abdualrhman-mehrez-340878373/' },
    { name: 'GitHub', icon: <FaGithub />, url: 'https://github.com/DUHUM3' },
    { name: 'Instagram', icon: <FaInstagram />, url: 'https://www.instagram.com/_3_xi/' },
{
  name: 'WhatsApp',
  icon: <FaWhatsapp />,
  url: 'https://wa.me/9660530532026?text=مرحبًا،%20أرغب%20في%20الاستفسار%20عن%20خدماتك'
},
{
  name: 'Mostaql',
  icon: <FaGlobe />,
  url: 'https://mostaql.com/u/abdualrhman021' // ← غيّره إلى اسمك في مستقل
}
];

  return (
    <div style={styles.container}>
      <div style={styles.content}>
        <header style={styles.header}>
          <h1 style={styles.title}>اتصل بي</h1>
          <p style={styles.subtitle}>يسعدني تواصلك معي عبر أي من القنوات التالية</p>
        </header>

        <div style={styles.contactInfo}>
          <h2 style={styles.infoTitle}>معلومات التواصل</h2>
          
          <div style={styles.infoItem}>
            <div style={styles.icon}><FaEnvelope /></div>
            <div style={styles.infoContent}>
              <div style={styles.infoLabel}>البريد الإلكتروني</div>
              <a href="mailto:abdurhmanmehrez@gmail.com" style={{...styles.infoText, ...styles.infoLink}}>abdurhmanmehrez@gmail.com</a>
            </div>
          </div>
          
          <div style={styles.infoItem}>
            <div style={styles.icon}><FaPhone /></div>
            <div style={styles.infoContent}>
              <div style={styles.infoLabel}>الهاتف / واتساب</div>
              <div style={styles.infoText}> 053 053 2026</div>
            </div>
          </div>
          
          <div style={styles.infoItem}>
            <div style={styles.icon}><FaMapMarkerAlt /></div>
            <div style={styles.infoContent}>
              <div style={styles.infoLabel}>العنوان</div>
              <div style={styles.infoText}>المملكة العربية السعودية, القصيم</div>
            </div>
          </div>
          
          <div style={styles.infoItem}>
            <div style={styles.icon}><FaClock /></div>
            <div style={styles.infoContent}>
              <div style={styles.infoLabel}>أوقات العمل</div>
              <div style={styles.infoText}>اوقات مفتوحه</div>
            </div>
          </div>

          <div style={styles.socialSection}>
            <h3 style={styles.socialTitle}>مواقع التواصل الاجتماعي</h3>
            <div style={styles.socialLinks}>
              {socialMedia.map((social, index) => (
                <a 
                  key={index} 
                  href={social.url} 
                  style={styles.socialLink}
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  <span style={styles.socialName}>{social.name}</span>
                  <span style={styles.socialIcon}>{social.icon}</span>
                </a>
              ))}
            </div>
          </div>
        </div>

        <div style={styles.contactForm}>
          <h2 style={styles.formTitle}>أرسل رسالة</h2>
          <form onSubmit={handleSubmit}>
            <div style={styles.formGroup}>
              <label htmlFor="fullName" style={styles.formLabel}>الاسم الكامل</label>
              <input 
                type="text" 
                id="fullName" 
                style={styles.formInput} 
                value={formData.fullName}
                onChange={handleChange}
                required 
              />
            </div>
            
            <div style={styles.formGroup}>
              <label htmlFor="email" style={styles.formLabel}>البريد الإلكتروني</label>
              <input 
                type="email" 
                id="email" 
                style={styles.formInput} 
                value={formData.email}
                onChange={handleChange}
                required 
              />
            </div>
            
            <div style={styles.formGroup}>
              <label htmlFor="subject" style={styles.formLabel}>الموضوع</label>
              <input 
                type="text" 
                id="subject" 
                style={styles.formInput} 
                value={formData.subject}
                onChange={handleChange}
                required 
              />
            </div>
            
            <div style={styles.formGroup}>
              <label htmlFor="message" style={styles.formLabel}>الرسالة</label>
              <textarea 
                id="message" 
                style={{...styles.formInput, ...styles.textArea}} 
                value={formData.message}
                onChange={handleChange}
                required
              ></textarea>
            </div>
            
            <button 
              type="submit" 
              style={styles.submitButton}
              disabled={isSubmitting}
            >
              {isSubmitting ? 'جاري الإرسال...' : 'إرسال الرسالة'}
            </button>

            {submitStatus.message && (
              <div style={{
                ...styles.statusMessage,
                ...(submitStatus.success ? styles.success : styles.error)
              }}>
                {submitStatus.message}
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;